import { useStorage } from '@vueuse/core'
import * as R from 'ramda'
import { RouteRecord } from 'vue-router'
const MenuCollapseKey = '__MENU_COLLAPSE__'
const activeMenuNameKey = '__ACTIVE_MENU_NAME__'
export default () => {
  const router = useRouter()
  const menuCollapse = useStorage(MenuCollapseKey, false, window.localStorage)
  const activeMenuName = useStorage(
    activeMenuNameKey,
    'FreightLiability',
    window.localStorage,
  )
  const activeLabel = computed(() =>
    R.pathOr(
      '',
      ['meta', 'title'],
      R.find(
        R.propEq(activeMenuName.value, 'name'),
        router.getRoutes() as any[],
      ) as RouteRecord,
    ),
  )

  return {
    menuCollapse,
    activeMenuName,
    activeLabel,
  }
}
